import classNames from "classnames";
import React from "react";
import { getColor } from "../../utils/generateColor";
import { withDefault } from "../../utils/withDefault";

interface Props {
  initials: string;
  colorHash?: string;
  size?: "medium" | "large";
  className?: string;
}

const PatientAvatar = (props: Props) => {
  const backgroundColor = getColor(withDefault(props.colorHash, props.initials));

  return (
    <div
      className={classNames("PatientAvatar", props.size, props.className)}
      style={{ backgroundColor: backgroundColor }}
    >
      {props.initials}
    </div>
  );
};

export default PatientAvatar;
